import {
  UPDATECURRENCYMASTERLIST_SUCCESS,
  UPDATECURRENCYMASTERLIST_FAILED,
  RESET_UPDATECURRENCYMASTERLIST,
  LOADING_UPDATECURRENCYMASTERLIST,
  NETWORK_ERROR_UPDATECURRENCYMASTERLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATECURRENCYMASTERLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATECURRENCYMASTERLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATECURRENCYMASTERLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATECURRENCYMASTERLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATECURRENCYMASTERLIST:
      return (state = initialState);
    default:
      return state;
  }
};
